export default __webpack_public_path__ + "static/media/openSansBold.6e27168f.ttf";